import React from 'react';
import Navbar from '../components/Layouts/Navbar';
import Footer from '../components/Layouts/Footer';
import KarriereHeader from '../components/Karriere/KarriereHeader';
import KarriereWachseMitUns from '../components/Karriere/KarriereWachseMitUns';
import KarriereWerte from '../components/Karriere/KarriereWerte';
import KarriereBenefits from '../components/Karriere/KarriereBenefits';
import SubscribeStyleOne from '../components/Common/SubscribeStyleOne';
import PageSeo from '../components/Common/PageSeo';
import KarriereJobsTabs from '../components/Karriere/KarriereJobsTabs';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';
import { fetchJobs } from '../lib/jobsApi';

const Karriere = ({ jobs = [] }) => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

    return (
        <>
            <PageSeo
                title={t('career_page_title')}
                description={t('career_page_description')}
                canonical={`${baseUrl}/karriere/`}
                openGraph={{
                    url: `${baseUrl}/karriere/`,
                    title: t('career_page_ogTitle'),
                    description: t('career_page_ogDescription'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1200,
                            height: 1200,
                            alt: t('career_page_ogImageAlt'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('career_page_ogSiteName'),
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow',
                    },
                    {
                        name: 'keywords',
                        content: t('career_page_keywords'),
                    },
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: 'https://simplify-data.de/karriere/'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: 'https://simplify-data.com/karriere/'
                    }
                ]}
            />
            <Navbar />
            <KarriereHeader />
            <KarriereWerte />

            <KarriereBenefits />

            <KarriereJobsTabs jobs={jobs} isLoading={false} />
            <KarriereWachseMitUns />
            <SubscribeStyleOne />
            <Footer />
        </>
    );
};

export async function getStaticProps() {
    try {
        const jobs = await fetchJobs();
        return {
            props: { jobs },
            revalidate: 300,
        };
    } catch {
        return { props: { jobs: [] }, revalidate: 60 };
    }
}

export default Karriere;
